import { useParams } from 'react-router-dom';

import OptionButton from '@/components/common/OptionButton/OptionButton';
import ArrowIcon from '@/components/common/OptionButton/icons/Arrow/ArrowIcon';
import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import useGetContractDetailsFromCache from '@/hooks/contract/useGetContractDetailsFromCache.hook';

export default function ViewUpliftsHistoryContainer() {
  const { contractId }: { contractId: UUID } = useParams();
  const contract = useGetContractDetailsFromCache(contractId);


  const getPath = () => {
    let path = browserHistory.location.pathname;

    const pathSegment = `uplifts-history/${encodeURIComponent(contractId)}`;

    if (path.indexOf(pathSegment) != -1) {
      path = path.replace(pathSegment, 'uplifts-history');
    }
    else {
      path += '/uplifts-history';
    }

    return path;
  };

  const getFullHref = () => {
    if (contract?.contractNumber) {
      return getParameterizedLink(`${getPath()}?contractNumber=${encodeURIComponent(contract?.contractNumber)}`);
    }
    return '#';
  };

  const handleNavigate = (e: React.MouseEvent) => {
    if ((e.ctrlKey || e.metaKey) && e.button === 0) {
      e.stopPropagation();
      return;
    }
    if (e.button === 0) {
      e.preventDefault();
      if (contract?.contractNumber) {
        browserHistory.push(getFullHref());
      }
    }
  };

  return (
    <a
      href={getFullHref()}
      onClick={handleNavigate}
      style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
    >
      <OptionButton
        onClick={(e) => e.preventDefault()}
        Icon={<ArrowIcon />}
      >
        View Uplift History
      </OptionButton>
    </a>
  );
}
